import { render, staticRenderFns } from "./edit-installation-address-dialog.vue?vue&type=template&id=0aed926b"
import script from "./edit-installation-address-dialog.vue?vue&type=script&lang=js"
export * from "./edit-installation-address-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aed926b')) {
      api.createRecord('0aed926b', component.options)
    } else {
      api.reload('0aed926b', component.options)
    }
    module.hot.accept("./edit-installation-address-dialog.vue?vue&type=template&id=0aed926b", function () {
      api.rerender('0aed926b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/installation/components/edit-installation-address-dialog.vue"
export default component.exports